import { NotificationManager } from 'react-notifications';
import moment, { Moment } from 'moment-timezone';

export const objectCleaner = (obj: {}): {} => 
  Object.keys(obj).reduce((acc, curr: string) => {
    const value = obj[curr];
    if (value) {
      acc[curr] = value;
    }
    return acc;
  },
{});

export const errorHandler = (error, setError: (error) => void) => {
  const responseData = error?.response?.data;
  const validationErrors = responseData?.errors;
  setError(error);
  if (validationErrors) {
    Object.values(validationErrors).flat().forEach((message) => {
      NotificationManager.error(message as string);
    });
  } else if (typeof responseData === 'string' && responseData.trim()) {
    NotificationManager.error(responseData);
  } else if (responseData?.title) {
    NotificationManager.error(responseData.title);
  } else if (responseData?.message) {
    NotificationManager.error(responseData.message);
  } else {
    NotificationManager.error(error.message);
  }
};

export const formatDateToCDT = (date: Moment | string) => moment.tz(typeof date === 'string' ? moment.utc(date) : moment(date), "America/Chicago").format('MMM Do YYYY h:mm a');

export const formatDateOnlyToCDT = (date: Moment | string) => moment.tz(typeof date === 'string' ? moment.utc(date) : moment(date), "America/Chicago").format('MMM Do YYYY');
